
export class TransmissionStation {
    id: number = 0;
    name: string = "";
    code: string = "";
    utilityId: number = 0;
    guid: string = "";
    electricalAddressCode: string = "";
}

export class CrudTsFilter {
    searchValue: string = "";
}

export enum CrudTsFilterBy {
    Name = 0,
    Code = 1
}